import Urls, { DEFAULT_OPTIONAL_PARAMETERS } from "../../constants/Urls";
import DiscussionRoomMapper from "../../mapper/DiscussionRoomMapper";
import ApplicationError from "../../utils/ApplicationError";
import ErrorLogger from "../../utils/ErrorLogger";
import { BEARER } from "../../utils/MyStore";
import ResponseService from "../../utils/ResponseService";
import {
  FETCHING_DISCUSSION_ROOM_FAILURE,
  FETCHING_DISCUSSION_ROOM_REQUEST,
  FETCHING_DISCUSSION_ROOM_SUCCESS,
} from "./types";

export const fetchingDiscussionRoomRequest = () => ({
  type: FETCHING_DISCUSSION_ROOM_REQUEST,
});

export const fetchingDiscussionRoomSuccess = (json) => ({
  type: FETCHING_DISCUSSION_ROOM_SUCCESS,
  payload: json,
});

export const fetchingDiscussionRoomFailure = (error) => ({
  type: FETCHING_DISCUSSION_ROOM_FAILURE,
  payload: error,
});

export const fetchDiscussionRoom = (
  language,
  _opts = DEFAULT_OPTIONAL_PARAMETERS
) => {
  return async (dispatch) => {
    dispatch(fetchingDiscussionRoomRequest());

    try {
      const route = Urls.exhibitions.discussion_rooms.show;
      const bearer = localStorage.getItem(BEARER);
      const headers = Urls.header.secure(bearer);
      const url = Urls.build(route.url(language), _opts.filters);

      let response = await fetch(url, {
        method: route.method,
        headers: headers,
      });

      let responseService = new ResponseService(DiscussionRoomMapper);

      let action = await responseService.call(
        response,
        (value) => fetchingDiscussionRoomSuccess(value),
        (error) => fetchingDiscussionRoomFailure(error)
      );

      dispatch(action);
    } catch (error) {
      ErrorLogger.call(this, error);
      dispatch(
        fetchingDiscussionRoomFailure(
          ApplicationError.buildApplicationError(error)
        )
      );
    }
  };
};
